import UnsubscribeForm from "@blocks/NewsLetterUnsubscribeForm/NewsLetterUnsubscribeForm";
import MainContainer from "@container/MainContainer";
import SideBlock from "@container/SideBlock/SideBlock";
import { PageAdTargetingTypeEnum } from "@typings/Ads.d";
export function NewsletterUnsubscribePage() {
  const sectionName = "eNewsLetter";
  const pageAdTargetValue = PageAdTargetingTypeEnum.LISTING;

  return (
    <MainContainer
      sectionName={sectionName}
      pageAdTargetValue={pageAdTargetValue}
      showNewsletterSignup={false}
    >
      <div className="max-w-screen-xl m-auto flex flex-col lg:flex-row">
        <div className="flex lg:px-sm flex-col w-12/12 lg:w-8/12 w-full gap-2 mb-10 lg:mb-0">
          <span className="text-gray-100 text-sm font-semibold">
            தினச்செய்தி மின்னஞ்சல்
          </span>
          <UnsubscribeForm />
        </div>
        <SideBlock
          sectionName={sectionName}
          className="w-full lg:block"
          pageAdTargetValue={pageAdTargetValue}
          sidebarSections={{}}
          mostRead={[]}
        />
      </div>
    </MainContainer>
  );
}
